export const shouldIncludeAssetInView = (asset, viewMode) => {
  if (viewMode === 'counter') {
    return true;
  }

  const isSynthetic = Boolean(asset?.is_synthetic);
  const isSyntheticPair = Boolean(asset?.is_synthetic_pair);

  if (viewMode === 'solo' && isSynthetic && !isSyntheticPair) {
    return false;
  }

  return true;
};

/**
 * TRADING (true) / SCANNER (false) of a row: a flag the client holds (a toggle,
 * or a per-row read) wins, else the one fetch-assets put on the row. Undefined
 * when neither is known — callers show such a row rather than hide it.
 */
export const tradingFlagFor = (asset, flags, key) => (
  key in flags ? flags[key] : asset?.trading
);

/** A virtual account shows what is enabled on it — and nothing when nothing is. */
export const isEnabledOnVirtual = (asset, enabled) => enabled.some((e) => (
  e.symbol === asset.symbol && (e.sectype === asset.sectype || (!e.sectype && !asset.sectype))
));

/** Sectype filter, as on Favorites: nothing picked shows everything. */
export const matchesSectypes = (asset, sectypes) => !sectypes.length || sectypes.includes(asset?.sectype);

/** The sectypes present among the assets, sorted, blanks dropped. */
export const sectypeOptions = (assets) => [...new Set(assets.map((a) => a.sectype).filter(Boolean))].sort();

export const filterAssetsForViewMode =(assets, viewMode) =>
  assets.filter((asset) => shouldIncludeAssetInView(asset, viewMode));
